const translations = {
    friday: 'Friday',
    monday: 'Monday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    thursday: 'Thursday',
    today: 'Today',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday'
};

export default translations;
